<template>
  <div class="main-content-wrapper">
    <!-- <div class="header_box"> -->
      <AppNewHeader
        style="width: 100%"
        :userName="userName"
        :placeholderText="'搜索知识资源'"
      />
    <!-- </div> -->
    <div class="main-conter">
      <div class="content_box">
        <div class="search-container">
            <el-input
              v-model="searchQuery"
              style="width: 1003px"
              placeholder="AI智能搜索"
              class="input-with-select"
              clearable
              @clear="handleClear"
              @blur="handleBlur"
              @keyup.enter="getResourceContent(searchQuery)"
            >
              <template #append>
                <el-button
                  @click="getResourceContent(searchQuery)"
                  :icon="Search"
                />
              </template>
            </el-input>
          </div>
      </div>
      
      <!-- 顶部盒子 -->
      <!-- 包裹除头部和底部外的内容 -->
      <div class="content_box">
        <!-- <KnowledgeIndex
          :knowledgeconter="knowledgeCards2"
          :activeNav="activeNav2"
          :keywordIndex="keyWordIndex"
          :knowData="dataList"
        ></KnowledgeIndex> -->
          <Newknowledgeindex
          :knowledgeconter="knowledgeCards2"
          :activeNav="activeNav2"
          :keywordIndex="keyWordIndex"
          :knowData="dataList"
        ></Newknowledgeindex>
      </div>
    </div>
    <el-footer>
      <AppFooter></AppFooter>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
// import KnowledgeIndex from "@/views/components/knowledgeindex.vue";
import Newknowledgeindex from "@/views/components/Newknowledgeindex.vue";
import { fetchResourceNavi, PostselectKnowledgeBaseList } from "@/api/index.js";
import { Search } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import bus from "@/mitt/bus.js";
const searchQuery = ref("");
const currentPage = ref(1);
import { Cookie } from "@/utils/Cookie";
const knowledgeCards2 = ref([]);
const dataList = ref([]);
const keyWordIndex = ref("");
const activeNav2 = ref("智汇三农");
const input2 = ref("");
const router = useRouter();
const route = useRoute();
// bus.on("indexKeyWord", (data) => {
//   getResourceContent("", data.data);
//   searchQuery.value = data.data;
// });
onUnmounted(() => {
  bus.off("indexKeyWord");
});

const handleClear = async () => {
  bus.emit("knowDataList", {
    message: "首页检索框",
    data: "",
  });
};

// const handleBlur = async () => {
//   getResourceContent("", searchQuery.value);
// };

const getResourceContent = (keyword) => {
  // dataList.value=  keyword
  bus.emit("knowDataList", {
    message: "首页检索框",
    data: keyword,
  });
  // try {
  //   const params = {
  //     pageIndex: currentPage.value,
  //     pageSize: "9",
  //     // contentCId: id,
  //     word: searchQuery.value,
  //   };
  //   const response = await PostselectKnowledgeBaseList(params);
  //   if (response.info) {
  //     // filteredKnowledgeCards.value = response.info.list;
  //     // knowledgeCards2.value = response.info.list
  //     bus.emit("knowDataList", {
  //       message: "首页检索框",
  //       data: response.info.list,
  //     });
  //     // filteredKnowledgeCards.value.forEach((item) => {
  //     //   item.check = false;
  //     // });
  //     // counttotal.value = response.info.total;
  //   } else {
  //     console.log("接口返回的数据为空或格式不正确");
  //   }
  // } catch (error) {
  //   console.error("获取数据失败:", error);
  // }
};

const handleSearch = (data) => {
  keyWordIndex.value = data;
};

const getResourceNavi = async () => {
  try {
    const params = {
      type: "content",
    };
    const response = await fetchResourceNavi(params);
    if (response.info) {
      knowledgeCards2.value = response.info;
      activeNav2.value = route.query.id === undefined ? "" : route.query.id;
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};

const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};

onMounted(() => {
  getResourceNavi();
  checkTokenStatus();

  searchQuery.value =
    route.query.keyword === undefined ? "" : route.query.keyword;
});
</script>

<style scoped>
.main-content-wrapper {
  width: 100%;
  position: relative; /* 确保子元素的定位基于此容器 */
}

.content_box {
  width: 1400px;
  margin: 0 auto;
  background-color: #fff;
}

.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.main-conter {
  width: 100%;
  /* background-color: rgba(245, 245, 245, 1); */
  background: #f5f5f5;
  position: relative; /* 确保内容不会被遮挡 */
  z-index: 1; /* 确保内容在 header_box 之上 */
  /* padding-top: 24px; */
}

.header_box {
  width: 100%;
  height: 136px;
  background: linear-gradient(
    180deg,
    rgba(47, 97, 224, 0.09) 0%,
    rgba(31, 85, 222, 0) 100%
  );
  position: relative; /* 确保 header_box 的定位 */
  z-index: 0; /* 确保 header_box 在 main-conter 之下 */
}

.bannerbox {
  width: 100%;
  height: calc(438px - 164px);
  background-image: url(@/assets/headerimage/2know.png);
  display: flex;
  justify-content: left;
  background-size: cover;
  background-repeat: no-repeat; /* 禁止重复平铺 */
}

.banner_content {
  /* width: 1400px; */
  margin-left: 290px;
}

.banner_title {
  /* 可以根据需要添加标题样式 */
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 32px;
  color: #2c77ff;
  line-height: 45px;
  text-align: center;
  font-style: normal;
  margin-top: 41px;
}

.banner_text {
  /* 可以根据需要添加文本样式 */
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  line-height: 33px;
  text-align: left;
  padding-left: 150px;
  font-style: normal;
  padding-top: 83px;
}

.el-input {
  width: 402px;
  height: 40px;
  /* background: #ffffff; */
  border-radius: 6px;
  border: none;
  color: #ffffff;
}
.search-container {
  display: flex;
  justify-content: center;
  /* margin-top: 42px;
  padding-left: 150px;     */
  padding: 24px;
    /* padding-left: 998px; */
}
.search-container :deep(.el-input-group__append) {
  border-left: 0;
  /* box-shadow: none !important; */
  width: 78px !important;
  background: #2c77ff !important;
  /* background-image: url(@/assets/headerimage/2inputbut.png);
  background-size: cover; */
  color: #ffffff !important;
  font-size: 18px;
  box-shadow: none;
  border-radius: 0;
}
.search-container :deep(.el-input__wrapper) {
  background: rgba(255, 255, 255, 0.21);
  /* box-shadow: none; */
  border-radius: 0;
}
.search-container :deep(.el-input__inner) {
  color: #333;
}
</style>
